module.exports = __webpack_public_path__ + "img/T1B_xs_03.49caaf05.png";